import ElementClassHandler from './utils/element-class-handler.js';
import Selectors from './utils/selectors.js';
import * as constants from './config/constants.js';
import Event from './utils/event.js';

export default class SectionControl {
    constructor(options = {}) {
        this.toggleIdentifier = options.toggleIdentifier || 'data-toggle-identifier';
        this.inputType = options.inputType;
        this.targetIdentifier = options.targetIdentifier || 'data-target-identifier';
        this.toggleRequiredSelect = options.toggleRequiredSelect || false;
        this.selectors = new Selectors();
        this.elementClassHandler = new ElementClassHandler;
    }

    setup() {
        this.setupToggleListener();
    }

    setupToggleListener() {
        let toggleFields = this.selectors.querySelectorArray(this.toggleIdentifier);
        let self = this;

        toggleFields.forEach(function(elem) {
            elem.addEventListener('change', (e) => {
                e.preventDefault();
                self.toggleTarget(elem.value);
            });
        });
    }

    toggleTarget(toggleValue) {
        let targetElem = document.querySelector(this.targetIdentifier);
        if (toggleValue == 1) {
            this.elementClassHandler.show(targetElem);
        } else {
            this.elementClassHandler.hide(targetElem);
        }

        let fields = this.selectors.querySelectorArray('input, select', targetElem);
        let self = this;
        fields.forEach(function(field) {
            if (toggleValue == 1) {
                if (self.toggleRequiredSelect) {
                    self.toggleRequiredSelectField(targetElem, true);
                }
            } else {
                self.resetField(field);

                if (self.toggleRequiredSelect) {
                    self.toggleRequiredSelectField(targetElem, false);
                }
            }
        });
    }

    toggleRequiredSelectField(element, isToggled) {
        element.querySelector('.' + constants.MDL_SELECTFIELD_SELECT_CLASS).required = isToggled;
    }

    resetField(field) {
        switch (field.type) {
            case 'checkbox':
                field.checked = false;
                if (typeof field.parentNode.MaterialCheckbox !== 'undefined') {
                    field.parentNode.MaterialCheckbox.uncheck();
                }
                break;
            case 'select-one':
                field.selectedIndex = 0;
                field.dispatchEvent(new Event('change'));
        }
    }
}
